import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import configureStore from 'app/store/configureStore';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from 'app/shared/App';
import { SsrRequestProvider } from 'app/context/common/SsrRequestProvider';
import '@encarpkg/design/dist/style.css';

export const { store, persistor } = configureStore();

const Root = () => (
	<HelmetProvider>
		<SsrRequestProvider>
			<Provider store={store}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</Provider>
		</SsrRequestProvider>
	</HelmetProvider>
);

export default Root;
